var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var _activeFetch, _debounceTimer, _debounceDelay;
import { C as Component } from "./component-cLJ9vlHA.js";
import { f as fetchConfig } from "./utilities-2Suih3Nm.js";
import { b as CartNoteUpdateEvent, T as ThemeAlertOpenEvent } from "./events-DeC3n8dp.js";
import "./critical-Da0Dmhh9.js";
class CartNote extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _activeFetch, null);
    __privateAdd(this, _debounceTimer, null);
    __privateAdd(this, _debounceDelay, 1e3);
  }
  // Wait 1 second after user stops typing
  connectedCallback() {
    super.connectedCallback();
    const { noteTextarea } = this.refs;
    if (noteTextarea && Theme.template.name === "cart") {
      this.boundHandleInput = this.handleInput.bind(this);
      noteTextarea.addEventListener("blur", this.boundHandleInput);
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    const { noteTextarea } = this.refs;
    if (noteTextarea && this.boundHandleInput) {
      noteTextarea.removeEventListener("blur", this.boundHandleInput);
    }
    if (__privateGet(this, _debounceTimer)) {
      clearTimeout(__privateGet(this, _debounceTimer));
    }
    if (__privateGet(this, _activeFetch)) {
      __privateGet(this, _activeFetch).abort();
    }
  }
  handleInput(event) {
    if (__privateGet(this, _debounceTimer)) {
      clearTimeout(__privateGet(this, _debounceTimer));
    }
    __privateSet(this, _debounceTimer, setTimeout(() => {
      this.updateCartNote(event);
    }, __privateGet(this, _debounceDelay)));
  }
  async updateCartNote(event) {
    event.preventDefault();
    const { noteTextarea, button } = this.refs;
    const note = noteTextarea.value;
    if (!(noteTextarea instanceof HTMLTextAreaElement)) return;
    if (__privateGet(this, _activeFetch)) {
      __privateGet(this, _activeFetch).abort();
    }
    const abortController = new AbortController();
    __privateSet(this, _activeFetch, abortController);
    this.classList.add("is-loading");
    noteTextarea.disabled = true;
    button == null ? void 0 : button.setAttribute("loading", "");
    try {
      const config = fetchConfig("json", {
        body: JSON.stringify({ note })
      });
      const response = await fetch(Theme.routes.cart_update_url, {
        ...config,
        signal: abortController.signal
      });
      if (response.ok) {
        document.dispatchEvent(new CartNoteUpdateEvent());
      } else {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = errorData.message || "Failed to update cart note";
        document.dispatchEvent(new ThemeAlertOpenEvent(errorMessage, "error"));
      }
    } catch (error) {
      if (error.name === "AbortError") return;
      const errorMessage = error.message || "An error occurred while updating cart note";
      document.dispatchEvent(new ThemeAlertOpenEvent(errorMessage, "error"));
    } finally {
      __privateSet(this, _activeFetch, null);
      this.classList.remove("is-loading");
      noteTextarea.disabled = false;
      button == null ? void 0 : button.removeAttribute("loading", "");
    }
  }
}
_activeFetch = new WeakMap();
_debounceTimer = new WeakMap();
_debounceDelay = new WeakMap();
if (!customElements.get("cart-note")) {
  customElements.define("cart-note", CartNote);
}
